import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import NoteTag from '@components/framework/tags/NoteTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';

interface ComponentProps {
  note: string;
  onChange: (note: string) => void;
  readOnly?: boolean;
  dataTestId?: string;
  secured?: SecuredConfig;
  maxLength?: number;
}

const ReservationCarrierNote: React.FC<ComponentProps> = ({ note, onChange, readOnly, dataTestId, secured, maxLength }) => {
  const { tr } = useTranslationLgs();

  return (
    <>
      <NoteTag
        label={tr(`ReservationCarrierNote.title`, `Note for carrier`)}
        note={note}
        onChangeNote={v => {
          onChange(v);
        }}
        readOnly={readOnly}
        dataTestId={dataTestId}
        secured={secured}
        maxLength={maxLength}
      />
    </>
  );
};

export default ReservationCarrierNote;
